var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#F16438",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_6648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 33.0742L36.4207 34.5384C36.864 34.8067 37.4065 34.41 37.2899 33.9084L36.6482 31.155L38.789 29.3C39.1799 28.9617 38.9699 28.32 38.4565 28.2792L35.639 28.04L34.5365 25.4384C34.3382 24.9659 33.6615 24.9659 33.4632 25.4384L32.3607 28.0342L29.5432 28.2734C29.0299 28.3142 28.8199 28.9559 29.2107 29.2942L31.3515 31.1492L30.7099 33.9025C30.5932 34.4042 31.1357 34.8009 31.579 34.5325L33.9999 33.0742Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 13.5254H25.1982C27.6006 13.5254 29.3975 14.0967 30.5889 15.2393C31.79 16.3818 32.3906 18.0078 32.3906 20.1172C32.3906 22.2852 31.7363 23.9795 30.4277 25.2002C29.1289 26.4209 27.1416 27.0312 24.4658 27.0312H20.833V35H14.168V13.5254ZM20.833 22.6807H22.459C23.7383 22.6807 24.6367 22.4609 25.1543 22.0215C25.6719 21.5723 25.9307 21.001 25.9307 20.3076C25.9307 19.6338 25.7061 19.0625 25.2568 18.5938C24.8076 18.125 23.9629 17.8906 22.7227 17.8906H20.833V22.6807Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_6648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(27 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarredIcon);
export default __webpack_public_path__ + "static/media/starred_icon.cc1298f01022cdfa5cfe225f4f02b947.svg";
export { ForwardRef as ReactComponent };